import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ContainerState } from './types';

export const initialState: ContainerState = {
  dealerNurturingAutomationSettings: { data: null, loading: false, error: null },
};

const dealerNurturingAutomationSettingsSlice = createSlice({
  name: 'dealerNurturingAutomationSettingsComponentState',
  initialState,
  reducers: {
    requestDealerNurturingAutomationSettings(
      state,
      _action: PayloadAction<any>,
    ) {
      state.dealerNurturingAutomationSettings.loading = true;
      state.dealerNurturingAutomationSettings.error = null;
      state.dealerNurturingAutomationSettings.data = {
        ...(state.dealerNurturingAutomationSettings.data || {}),
        body: [],
      };
    },
    requestDealerNurturingAutomationSettingsSuccess(
      state,
      action: PayloadAction<any>,
    ) {
      state.dealerNurturingAutomationSettings.data = action.payload;
      state.dealerNurturingAutomationSettings.loading = false;
    },
    requestDealerNurturingAutomationSettingsError(
      state,
      action: PayloadAction<any>,
    ) {
      state.dealerNurturingAutomationSettings.error = action.payload;
      state.dealerNurturingAutomationSettings.loading = false;
    },
    requestUpdateDealerNurturingAutomationSettings(
      state,
      _action: PayloadAction<any>,
    ) {
      state.dealerNurturingAutomationSettings.loading = true;
      state.dealerNurturingAutomationSettings.error = null;
    },
    requestUpdateDealerNurturingAutomationSettingsSuccess(state) {
      state.dealerNurturingAutomationSettings.loading = false;
    },
    requestUpdateDealerNurturingAutomationSettingsError(
      state,
      action: PayloadAction<any>,
    ) {
      state.dealerNurturingAutomationSettings.error = action.payload;
      state.dealerNurturingAutomationSettings.loading = false;
    },
  },
});

export const {
  actions: dealerNurturingAutomationSettingsActions,
  reducer,
  name: sliceKey,
} = dealerNurturingAutomationSettingsSlice;
